import { TSelectOption } from 'src/app/project/components/input/select-tag/select-tag.model';
import { TSelectDropdownData } from 'src/app/project/components/input/select/select-dropdown/select-dropdown.model';
import { translate } from 'src/app/project/features/translate/translate';
import {
  ESemiSimplePermission,
  ESimplePermission,
} from 'src/app/project/modules/share/permissions.consts';
import { EUserRole } from '../../../share/share-utils/user-roles';
import { EColumn } from '../../user-management.consts';
import {
  TPermissionItemsByColumn,
  getPermissionItemsByColumn,
} from './permissions-per-column.utils';

export const getDropdownDataForColumn = (
  column: EColumn,
  userRole: EUserRole,
  currentPermission: ESimplePermission | ESemiSimplePermission,
  customFieldId: string = null,
): TSelectDropdownData => {
  const permissionItemsByColumn = getPermissionItemsByColumn(column, userRole, customFieldId);

  return {
    noSearchBar: true,
    items: permissionItemsByColumn.map((item) => ({
      value: item.value,
      iconSrc: item.iconSrc,
      label: translate(item.translationKey),
    })),
    selectedItem: tryFindSelectedPermissionItem(permissionItemsByColumn, currentPermission),
  };
};

const tryFindSelectedPermissionItem = (
  permissionItemsByColumn: TPermissionItemsByColumn,
  currentPermission: ESimplePermission | ESemiSimplePermission,
): TSelectOption => {
  const item = permissionItemsByColumn.find(
    (permissionByColumn) => permissionByColumn.value === currentPermission,
  );

  if (!item) {
    return null;
  }

  return {
    value: item.value,
    iconSrc: item.iconSrc,
    label: translate(item.translationKey),
  };
};
